// components/DocumentUploadModal.js
import { Modal } from './modal.ts';
import { uploadDocument } from '../services/api.ts';

export class DocumentUploadModal {
  constructor(siteId) {
    this.siteId = siteId;
    this.modal = new Modal();
  }

  open() {
    const html = `
      <div class="document-upload">
        <div class="modal-header">
          <h3>Upload Document</h3>
        </div>
        <div class="modal-body">
          <form id="document-upload-form" enctype="multipart/form-data">
            <input type="hidden" name="siteId" value="${this.siteId}">

            <div class="form-grid">
              <div>
                <label>Name *</label>
                <input name="name" required maxlength="150" placeholder="Document Name">
              </div>

              <div>
                <label>Link Type</label>
                <select name="linkType">
                  <option value="plant">Plant</option>
                  <option value="local">Local</option>
                  <option value="external">External</option>
                </select>
              </div>

              <div>
                <label>Source</label>
                <input name="source" placeholder="e.g. Site/PPC">
              </div>

              <div>
                <label>Author</label>
                <input name="author" placeholder="Author Name">
              </div>

              <div>
                <label>Last Modifier</label>
                <input name="lastModifier" placeholder="Last Modifier">
              </div>

              <div>
                <label>Tags (comma separated)</label>
                <input name="tags" placeholder="e.g. report, monthly">
              </div>

              <div class="full-width">
                <label>File *</label>
                <input type="file" name="document" required>
              </div>
            </div>

            <div class="form-actions" style="margin-top: 1.5rem;">
              <button type="submit" class="btn-primary">Upload</button>
            </div>
          </form>
        </div>
      </div>
    `;

    this.modal.open(html);

    const form = this.modal.contentEl.querySelector("#document-upload-form");

    form.onsubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData(form);

      try {
        const uploadedDoc = await uploadDocument(formData);
        alert("Document uploaded successfully!");
        this.modal.close();

        // Dispatch a custom event so DocumentsPage can update its table dynamically
        const event = new CustomEvent("documentUploaded", { detail: uploadedDoc });
        document.dispatchEvent(event);

      } catch (err) {
        console.error("Upload error:", err);
        alert("Failed to upload document: " + (err.message || ""));
      }
    };
  }
}
